<template>
  <div class="immersive-wrapper">
    <div v-for="(embed, embedIdx) in EmbedFilters" :key="'e-' + embedIdx" :style="'font-size: 20px;'">
      <h2 style="" class="chapter-title">
        <a :name="'e-' + embed.Data.Id" :style="'color:#aeaeae;font-size:40px'">
          {{ embed.Data.Title }}
        </a>
      </h2>
      <div class="breadcrumb">
        <strong>Under: </strong>{{ embed.Data.EmbedArea }}
      </div>
      <div v-if="embed.Data.StartLine > -1 && embed.Data.EndLine > -1">
        <iframe :src="embed.Data.EmbedUrl" style="
            width: 80%;
            border: 0px;
            margin-left: 10px;
            margin-top: 10px;
            height: 400px;
          " />
      </div>
      <div class="chapter-content" style="margin-left: 10px; margin-top: 50px; max-width: 80%"
        v-html="embed.Data.Description"></div>
      <EmbedImmersiveContent :EmbedFilters="embed.Children"></EmbedImmersiveContent>
    </div>
  </div>
</template>

<script>
import Textarea from "../../../../forms/form-elements/textarea/Textarea.vue";
export default {
  data() {
    return {};
  },
  props: ["EmbedFilters"],
  components: {
    EmbedImmersiveContent: () =>
      import(
        "@/views/components/organisms/embeds/embeds-immersive/EmbedImmersiveContent.vue"
      ),
    Textarea,
  },
};
</script>
<style scoped>
*>>>img {
  max-width: 100%;
  margin: 0 auto !important;
  border: 5px solid #efefef;
}

*>>>.chapter-title {
  padding: 0px;
  margin-top: 50px;
  margin-bottom: 0px;
  max-width: 80%;
}

*>>>.breadcrumb {
  font-size: 12px;
  max-width: 80%;
  display: none;
}

*>>>ul {
  margin: 40px 10px 10px 10px;
}
</style>
